/**
 * Enumerates all supported visual categories for the custom map layers panel.
 *
 * Each category is rendered as a collapsible group in the custom Angular UI.
 */
export enum MapLayerCategoryEnum {
    BASE = 'base',
    COORDINATION_AREAS = 'coordination-areas',
    INFRASTRUCTURE = 'infrastructure',
    OPERATIONS = 'operations',
    POLICE_AREAS = 'police-areas',
    NEAR_SEARCH = 'near-search',
    RELAY = 'relay',
    TRAJECTORY = 'trajectory',
    DEBUG = 'debug'
}
